// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics"; // Import analytics
import { getAuth } from "firebase/auth"; // Import auth if you're using authentication
import { getDatabase, ref, set } from "firebase/database"; // Import Realtime Database functions

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC7HFHaaq8rvB1EqkO6d1mNFoanvtnS3fE",
  authDomain: "butterflywings-c1068.firebaseapp.com",
  projectId: "butterflywings-c1068",
  storageBucket: "butterflywings-c1068.appspot.com",
  messagingSenderId: "672287404701",
  appId: "1:672287404701:web:31de6c1241a0b8e0c79a74",
  measurementId: "G-QSSQNJHPV2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app); // Initialize analytics
const auth = getAuth(app); // Initialize Firebase Authentication
const database = getDatabase(app); // Initialize Firebase Realtime Database

// Export necessary modules
export { auth, database, ref, set }; // Export auth, database, ref, and set
